import React, { useEffect, useState } from "react";
import editIcon from "../../assets/images/editIcon.svg";
import supportIcon from "../../assets/images/supportIcon.svg";
import languageIcon from "../../assets/images/languageIcon.svg";
import notificationManageIcon from "../../assets/images/notificationManageIcon.svg";
import rightArrowGrey from "../../assets/images/rightArrowGrey.svg";
import logoutMobile from "../../assets/images/logoutMobile.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../i18n";
import LanguageChangeModal from "./LanguageChangeModal";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfileHandler } from "../../redux/action/getUserProfile";
import Loader from "../Loder/loader";
import { getItem } from "../../common/localStorage";

const Settings = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const getUserProfile = JSON.parse(getItem("loginResponse"));
  const [isLogoutModal, setIsLogoutModal] = useState(false);
  const getUserProfileSelector = useSelector(
    (state) => state?.getUserProfileData
  );
  const setLanguageSelector = useSelector((state) => state?.setLanguageMain);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getUserProfileHandler());
  }, []);

  const handleSwitchChange = () => {
    setIsModalOpen(true);
  };

  const handleCancelChange = () => {
    setIsLogoutModal(false);
  };

  const handleConfirmChange = () => {
    setIsLogoutModal(false);
    localStorage.clear();
    window.location.replace("/");
  };

  return (
    <>
      {getUserProfileSelector?.isLoading === true ||
      setLanguageSelector?.isLoading === true ? (
        <Loader loaderTransForm="loaderTransForm" />
      ) : (
        <div className="mainSection">
          <div className="w-lg-50">
            <div className="mb-30">
              <div className="fs-16 gb fw-700 mb-12">{t("Profile")}</div>
              <div className="profileName">
                <div className="div d-flex align-center gap-16">
                  <div className="nameInitials  gb">{`${
                    getUserProfile?.firstName?.charAt(0) || ""
                  }${getUserProfile?.lastName?.charAt(0) || ""}`}</div>
                  <h3 className="fw-600">
                    {getUserProfile?.firstName + " " + getUserProfile?.lastName}
                  </h3>
                </div>
                <img
                  src={editIcon}
                  alt=""
                  className="cursor-pointer"
                  onClick={() => navigate("/profile-change")}
                />
              </div>
            </div>
            <div>
              <div className="fs-16 gb fw-700 mb-12">{t("Settings")}</div>
              <div className="mobileDesign">
                <div
                  className="settingsChange mb-10"
                  onClick={() => navigate("/support-request")}
                >
                  <div className="div d-flex align-center gap-16">
                    <img src={supportIcon} alt="" />
                    <h3 className="fw-600">{t("Support Request")}</h3>
                  </div>
                  <img src={rightArrowGrey} alt="" />
                </div>
                <div
                  className="settingsChange mb-10"
                  onClick={() => navigate("/manage-notification")}
                >
                  <div className="div d-flex align-center gap-16">
                    <img src={notificationManageIcon} alt="" />
                    <h3 className="fw-600">{t("Manage Notifications")}</h3>
                  </div>
                  <img src={rightArrowGrey} alt="" />
                </div>
                <div
                  className="settingsChange mb-10"
                  onClick={handleSwitchChange}
                >
                  <div className="div d-flex align-center gap-16">
                    <img src={languageIcon} alt="" />
                    <h3 className="fw-600">{t("Language")}</h3>
                  </div>
                  <div className="d-flex align-center gap-6">
                    <span className="text-grey">
                      {getItem("language") === "en" ? "English" : "Spanish"}
                    </span>
                    <img src={rightArrowGrey} alt="" />
                  </div>
                </div>
                <div
                  className="settingsChange mb-10 mobileShow"
                  onClick={() => setIsLogoutModal(true)}
                >
                  <div className="div d-flex align-center gap-16">
                    <img src={logoutMobile} alt="" />
                    <h3 className="fw-600">{t("Logout")}</h3>
                  </div>
                </div>
              </div>
              {isModalOpen && (
                <LanguageChangeModal
                  isModalOpen={isModalOpen}
                  setIsModalOpen={setIsModalOpen}
                />
              )}
              {isLogoutModal && (
                <Modal
                  className="custom-modal responsiveModal text-center"
                  open={isLogoutModal}
                  onCancel={handleCancelChange}
                  footer={null}
                  closeIcon={null}
                  centered
                  maskClosable={false}
                >
                  <div className="gb fs-20 mb-12 text-center">
                    {t("Are you sure to log out?")}
                  </div>

                  <div className="yesNoOption">
                    <button className="noBtn" onClick={handleCancelChange}>
                      {t("Cancel")}
                    </button>
                    <button className="yesBtn" onClick={handleConfirmChange}>
                      {t("Yes")}
                    </button>
                  </div>
                </Modal>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Settings;
